import { Link } from 'react-router';
import styles from './CaseStudyBanner.module.scss';

type CaseStudyBannerProps = {
  config: { logo: React.ReactNode; bannerUrl: string; description: string; link: string };
};

export const CaseStudyBanner = ({ config }: CaseStudyBannerProps) => {
  return (
    <div className={styles.sectionBanner}>
      <h4 className={styles.sectionBannerHeading}>Spotlight Case Study</h4>
      <div className={styles.sectionBannerContentLayout}>
        <div className={styles.logo}>{config.logo}</div>
        <p className={styles.sectionBannerDescription}>{config.description}</p>
        <Link className={styles.titleBannerBackLink} to={config.link}>
          <span>Case study</span>
        </Link>
      </div>
    </div>
  );
};
